import React from 'react';
import { EyeIcon } from '@heroicons/react/24/solid';

interface StatisticsProps {
  propertyViews: number;
}

const PropertyStatistics: React.FC<StatisticsProps> = ({ propertyViews }) => {
  return (
    <div className="bg-white p-5 sm:p-6 md:p-8 rounded-xl shadow-lg">
      <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800 mb-4 sm:mb-5 md:mb-6">
        Statistics
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-5 md:gap-6">
        <div className="flex items-center text-sm sm:text-base text-gray-600">
          <EyeIcon className="w-5 h-5 sm:w-6 sm:h-6 mr-2 sm:mr-3 text-blue-500" />
          <span>{propertyViews} Property Views</span>
        </div>
      </div>
    </div>
  );
};

export default PropertyStatistics;
